import { i18n, OFFER_STATUS } from "data/i18n"



export const OfferStatus = ({ status }) => {
    if (!status) {
        return <span>Отсутсвует</span>
    }
    let className = ''
    if (status === OFFER_STATUS.IN_REVIEW) {
        className = "color-yellow"
    }

    if (status === OFFER_STATUS.NOT_AVAILABLE) {
        className = "color-red"
    }

    if (status === OFFER_STATUS.AVAILABLE) {
        className = "color-green"
    }

    return (
        <span className={className}>
            <span style={{ fontSize: '18px', paddingTop: '8px', display: "block" }}>{i18n[status]} </span>
        </span>
    )
}
